//Local constants to the form
export const ALPHANUMERIC_ERROR = "Your short url must be alphanumeric. Can contain letters, numbers or a hyphen(-)";
export const MAX_LOCATION_MESSAGE = "You have already exceeded your locations. Please contact us to upgrade your plan. Feel free to chat with us in the chat box at the bottom right."
export const NAME_ADDRESS_MISSING = "Please enter a name or address";
export const UPLOAD_ERROR = "There was an error uploading your files. Please try again or submit without a menu and send your menu in the chat box at the bottom right";
export const URL_ERROR = "Your short url must be minimum 3 characters.";
export const URL_INVALID = "Your short url is already in use or invalid. Please try something else.";
export const URL_VALID = "Valid short url!";

export const DIET_DESCRIPTIONS = {
    glutenFree: "Is your restaurant 100% Gluten-Free?",
    peanutFriendly: "Does your restaurant take satisfactory steps to accommodate peanut allergies?",
    shellfishFriendly: "Does your restaurant take satisfactory steps to accommodate shellfish allergies?",
    treenutFriendly: "Does your restaurant take satisfactory steps to accommodate treenut allergies?",
    dairyFriendly: "Does your restaurant take satisfactory steps to accommodate dairy allergies?",
    eggFriendly: "Does your restaurant take satisfactory steps to accommodate egg allergies?",
    sesameFriendly: "Does your restaurant take satisfactory steps to accommodate sesame allergies?",
    soyFriendly: "Does your restaurant take satisfactory steps to accommodate soy allergies?",
    gfFoodPrep: "Does your restaurant have a dedicated gluten-free food preparation area to prevent cross contamination?",
    gfFriendly: "Does your restaurant have gluten-free options available?",
    vegan: "Is your restaurant 100% vegan?",
    allergyFriendly: "Is your restaurant comfortable serving people with severe allergies?",    
    lowCarb: "Does your restaurant have low carb options?",
    veganFriendly: "Does your restaurant have any Vegan options?",
    vegetarian: "Is your restaurant 100% Vegetarian?",
    kosher : "Is your restaurant certified kosher?",
    halal  : "Is your restaurant certified halal?",
    
};

export const DIET_NAMES_FORMATTED = {
    glutenFree: "100% Gluten-Free",
    peanutFriendly: "Peanut Allergy Friendly",
    shellfishFriendly: "Shellfish Allergy Friendly",
    treenutFriendly: "Treenut Allergy Friendly",
    dairyFriendly: "Dairy Allergy Friendly",
    eggFriendly: "Egg Allergy Friendly",
    sesameFriendly: "Sesame Allergy Friendly",
    soyFriendly: "Soy Allergy Friendly",
    gfFoodPrep: "Gluten-Free Food Prep",
    gfFriendly: "Gluten-Free Friendly",
    vegan: "Vegan",
    allergyFriendly: "Allergy Friendly",
    lowCarb: "Low Carb",
    veganFriendly: "Vegan Friendly",
    vegetarian: "100% Vegetarian",    
    kosher : "Kosher",
    halal  : "Halal",
};

export const DIET_TAGS = [
    {
        name: "glutenFree", value: 1
    },
    {
        name: "peanutFriendly", value: 2
    },
    {
        name: "shellfishFriendly", value: 4
    },
    {
        name: "treenutFriendly", value: 8
    },
    {
        name: "dairyFriendly", value: 16
    },
    {
        name: "eggFriendly", value: 32
    },
    {
        name: "sesameFriendly", value: 64
    },
    {
        name: "soyFriendly", value: 128
    },
    {
        name: "gfFoodPrep", value: 256
    },
    {
        name: "gfFriendly", value: 512
    },
    {
        name: "vegan", value: 1024   
    },
    {
        name: "allergyFriendly", value: 2048
    },
    {
        name: "lowCarb", value: 4096
    },    
    {
        name: "veganFriendly", value: 8192, 
    },
    {
        name: "vegetarian", value: 16384,
    },   
    {
        name: "kosher", value: 32768
    },    
    {
        name: "halal", value: 65536
    }
];


// WEBPACK FOOTER //
// ./src/components/LocationForm/constants.js